<template>
    <Avatar
        :username="name"
        :src="name"
        color="#fff"
        style="vertical-align: middle"
        :inline="true"
        v-bind="$attrs"
    />
</template>

<script setup lang="ts">
import Avatar from './avatar.vue';

defineProps({
    name: {
        type: String,
        default: ''
    }
});
</script>
